export type Disc = 0 | 1 | 2;
export type Board = Disc[];

const DIRS: [number, number][] = [[-1, -1], [-1, 0], [-1, 1], [0, -1], [0, 1], [1, -1], [1, 0], [1, 1]];

export function startBoard(n: number): Board {
  return new Array(n * n).fill(0);
}

export function flips(b: Board, n: number, idx: number, player: 1 | 2): number[] {
  if (b[idx] !== 0) return [];
  const other = player === 1 ? 2 : 1;
  const r0 = Math.floor(idx / n), c0 = idx % n;
  const out: number[] = [];
  for (const [dr, dc] of DIRS) {
    const line: number[] = [];
    let r = r0 + dr, c = c0 + dc;
    while (r >= 0 && r < n && c >= 0 && c < n && b[r * n + c] === other) {
      line.push(r * n + c);
      r += dr;
      c += dc;
    }
    if (line.length && r >= 0 && r < n && c >= 0 && c < n && b[r * n + c] === player) out.push(...line);
  }
  return out;
}

export function legalMoves(b: Board, n: number, player: 1 | 2): number[] {
  const out: number[] = [];
  for (let i = 0; i < b.length; i++) if (flips(b, n, i, player).length) out.push(i);
  return out;
}

export function openMoves(b: Board, n: number, player: 1 | 2): { cells: number[]; open: boolean } {
  const turning = legalMoves(b, n, player);
  if (turning.length) return { cells: turning, open: false };
  const empty: number[] = [];
  b.forEach((d, i) => { if (d === 0) empty.push(i); });
  return { cells: empty, open: true };
}

export function play(b: Board, n: number, idx: number, player: 1 | 2): Board | null {
  if (b[idx] !== 0) return null;
  const f = flips(b, n, idx, player);
  if (!f.length && legalMoves(b, n, player).length) return null;
  const next = [...b];
  next[idx] = player;
  for (const i of f) next[i] = player;
  return next;
}

export function count(b: Board): { dark: number; light: number } {
  let dark = 0, light = 0;
  for (const d of b) { if (d === 1) dark++; else if (d === 2) light++; }
  return { dark, light };
}
